import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { HelperService } from 'src/app/utils/helper.service';
import { AnexoService } from '../anexo/anexo.service';
import { FormArray, FormBuilder, FormControl } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'anexo-drag-drop',
  templateUrl: './anexo-drag-drop.component.html',
  styleUrls: ['./anexo-drag-drop.component.css']
})
export class AnexoDragDropComponent {
  isDragging: boolean;
  pendingFiles: any[] = [];
  @Input() nomeFormDisabled = false;
  @Input() dataFormDisabled = false;
  @Input() tipoFormDisabled = false;
  @Input() tipoAnexoDefault: number | null = null;
  @Input() disabled = false;
  @Input() label = 'Anexo';
  @Input() multiple = false;
  @Input() controlArray: FormArray = new FormArray([]);
  @Output() pending: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private snackbar: SnackBarService,
    private anexoService: AnexoService,
    private fb: FormBuilder,
    public helper: HelperService,
  ) {
    this.controlArray.valueChanges.subscribe({ next: value => console.log(value) })
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false;

    if (event.dataTransfer?.files) {
      this.handleFiles(event.dataTransfer.files);
    }
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.handleFiles(input.files);
    }
  }
  private handleFiles(files: FileList) {
    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      if (!this.validateFile(file)) {
        continue;
      }

      this.pendingFiles.unshift({ file, loading: true, cancelSubject: new Subject<void>() });
      this.updatePending();
      this.uploadFile(file);

      if (!this.multiple) {
        break;
      }

    }
  }
  private validateFile(file: File): boolean {
    // Example validation - adjust as needed
    const maxSize = 100 * 1024 * 1024; // 100MB
    // tipos backend mimes:001,002,003,004,005,006,007,008,009,010,011,012,013,014,015,016,017,018,019,020,7z,doc,docx,html,jpeg,jpg,mp3,mp4,ods,odt,pdf,pptx,rar,txt,xls,xlsx,zip
    const allowedTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",  // DOCX
      "application/msword",                                                       // DOC
      "application/x-7z-compressed",                                              // 7z
      "text/html",                                                                // HTML
      "audio/mpeg",                                                               // MP3
      "video/mp4",                                                                // MP4
      "application/vnd.oasis.opendocument.spreadsheet",                           // ODS
      "application/vnd.oasis.opendocument.text",                                  // ODT
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",// PPTX
      "application/vnd.rar",                                                      // RAR
      "text/plain",                                                               // TXT
      "application/vnd.ms-excel",                                                 // XLS
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",        // XLSX
      "application/zip"                                                           // ZIP
    ];
    if (file.size > maxSize) {
      this.snackbar.showSnackBarError(`Arquivo muito grande: ${file.name} (max ${this.helper.formatBytes(maxSize)})`);
      return false;
    }

    if (!allowedTypes.includes(file.type)) {
      this.snackbar.showSnackBarError(`Tipo de arquivo inválido: ${file.name}`);
      return false;
    }

    return true;
  }

  private getAnexoFormData(file: File) {
    let formData = new FormData();
    formData.append("arquivo", file);
    return formData;
  }

  private uploadFile(file: File) {
    const index = this.pendingFiles.findIndex(f => f.file === file);

    this.anexoService.uploadTemp(this.getAnexoFormData(file))
      .pipe(takeUntil(this.pendingFiles[index].cancelSubject))
      .subscribe({
        next: (res: any) => {
          const file = this.pendingFiles.splice(index, 1)[0];
          this.updatePending();

          if (!this.multiple)
            this.controlArray.clear();

          this.controlArray.push(this.fb.group({
            id: this.fb.control(null),
            token: this.fb.control(res.token),
            nome: this.fb.control(""),
            dataDocumento: this.fb.control(""),
            tamanho: this.fb.control(file.file.size),
            nomeArquivo: this.fb.control(file.file.name),
            tipoAnexo: this.fb.control(this.tipoAnexoDefault ?? "")
          }));
        },
        error: (err) => {
          this.pendingFiles = this.pendingFiles.filter(f => f.file !== file);
          this.updatePending
          this.snackbar.showSnackBarError(`Upload falhou: ${file.name}`);
        },
      });
  }
  cancelUpload(file: { file: File, loading: true, cancelSubject: Subject<void> }) {
    const index = this.pendingFiles.findIndex(f => f.file === file);
    this.pendingFiles[index].next();
    this.pendingFiles[index].complete();
    this.pendingFiles = this.pendingFiles.filter(f => f.file !== file.file);
    this.updatePending();
  }

  removeAnexo(anexoId: null | number, anexoToken: null | string) {
    if (anexoId) {
      this.controlArray.controls.filter(control => control.value.id !== anexoId);
    }
    if (anexoToken) {
      this.controlArray.controls.filter(control => control.value.token !== anexoToken);
    }
  }
  
  updatePending() {
    this.pending.emit(this.pendingFiles.length != 0);
  }
}
